import { translate } from "app/filters/i18nFilter";
import dayjs from "single-spa/dayjs-extend";

const TIME_FORMAT = "h:mm A";
const FULL_FORMAT_SAME_YEAR = "MMM D, h:mm A";
const FULL_FORMAT_OTHER_YEAR = "MMM D, YYYY, h:mm A";

export const formatLastActivity = (isoDate: string): string => {
    const date = dayjs.utc(isoDate).local();

    if (!date.isValid()) {
        return "";
    }

    const now = dayjs();

    if (date.isSame(now, "day")) {
        return translate("si.pages.home.last_activity.today_at", {
            time: date.format(TIME_FORMAT),
        });
    }

    if (date.isSame(now.subtract(1, "day"), "day")) {
        return translate("si.pages.home.last_activity.yesterday_at", {
            time: date.format(TIME_FORMAT),
        });
    }

    return date.year() === now.year() ? date.format(FULL_FORMAT_SAME_YEAR) : date.format(FULL_FORMAT_OTHER_YEAR);
};
